module.exports = __webpack_public_path__ + "static/ngpm-cut-7889a171a1535fdd107a87f820e4d6c5.mp4";